import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import VueYouTubeEmbed from 'vue-youtube-embed'
import VueCalendly from 'vue-calendly';
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";
import mixpanel from 'mixpanel-browser';
import VueJivosite from '@bchteam/vue-jivosite'

Vue.use(VueYouTubeEmbed)
Vue.use(VueCalendly);
Vue.config.productionTip = false

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCYAMsk559tqcjsiQE3cui7XeDzdYM3Lvk",
  authDomain: "consultoria-siproquim.firebaseapp.com",
  databaseURL: "https://consultoria-siproquim-default-rtdb.firebaseio.com",
  projectId: "consultoria-siproquim",
  storageBucket: "consultoria-siproquim.appspot.com",
  messagingSenderId: "686402554809",
  appId: "1:686402554809:web:82bd5864ec16713e978468",
  measurementId: "G-3E7Q1FLB9F",
};

// Initialize Firebase
const firesbaseApp = initializeApp(firebaseConfig);
const analytics = getAnalytics(firesbaseApp);
const db = getFirestore();
const storage = getStorage();
mixpanel.init('3af62e72d963beda63e85b285a1b902b', {debug: true}); 
mixpanel.track('Visited site');
Vue.use(VueJivosite, { widgetId: 'KH4D5wCdW5' })

const animals = require('@/assets/data/animals.json')
const adjectives = require('@/assets/data/adjectives.json')

const util = require("./util");

function generateRandomAnimal() {
  const adjective = adjectives[util.aRandom(adjectives.length)]
  const animal = animals[util.aRandom(animals.length)]
  return `${util.capitalizeFirstLetter(adjective)} ${util.capitalizeFirstLetter(animal)}`
}

if (require.main === module) {
  console.log(generateAnimal())
}

export {db, analytics, storage, mixpanel, generateRandomAnimal}

new Vue({
  vuetify,
  firesbaseApp,
  render: h => h(App)  
}).$mount('#app')
